import React from 'react';

export const DEFAULT_USER_AVATAR_PREF = {
  avatarId: 'human-default',
  avatarBackground: '210',
};

export const USER_AVATAR_OPTIONS = [
  { id: 'human-default', label: 'Classic' },
  { id: 'human-crop', label: 'Crop' },
  { id: 'human-curly', label: 'Curly' },
  { id: 'human-long', label: 'Long' },
  { id: 'human-buzz', label: 'Buzz' },
  { id: 'human-wavy', label: 'Wavy' },
  { id: 'human-parted', label: 'Parted' },
  { id: 'human-coily', label: 'Coily' },
  { id: 'human-bob', label: 'Bob' },
  { id: 'human-sweep', label: 'Sweep' },
  { id: 'human-ponytail', label: 'Ponytail' },
  { id: 'human-bangs', label: 'Bangs' },
  { id: 'human-braids', label: 'Braids' },
  { id: 'human-fade', label: 'Fade' },
  { id: 'human-shag', label: 'Shag' },
];

export const USER_AVATAR_BACKGROUND_SLIDER_MIN = 0;
export const USER_AVATAR_BACKGROUND_SLIDER_MAX = 360;
export const USER_AVATAR_BACKGROUNDS = [
  { id: 'sky', label: 'Sky', color: '#dbeafe', hue: 210 },
  { id: 'mint', label: 'Mint', color: '#d1fae5', hue: 155 },
  { id: 'rose', label: 'Rose', color: '#ffe4e6', hue: 350 },
  { id: 'slate', label: 'Slate', color: '#e2e8f0', hue: 215 },
];

const AVATAR_VARIANTS = {
  'human-default': {
    hair: '#334155',
    skin: '#f4d7b5',
    shirt: '#cbd5e1',
    mouth: '#9a3412',
    hairPath: 'M15.8 19.2c0-5.6 3.6-10 8.2-10 4.8 0 8.6 4 8.6 9.4 0 1.5-.3 2.8-.9 4.1-.8-1.8-2.1-3.4-4.4-4.4-2.7 2.4-6.5 3.6-11.3 3.5-.1-.6-.2-1.6-.2-2.6Z',
  },
  'human-crop': {
    hair: '#1e293b',
    skin: '#ddb892',
    shirt: '#93c5fd',
    mouth: '#7c2d12',
    hairPath: 'M15.4 18.7c.3-5.2 3.9-8.6 8.7-8.6 4.6 0 8 3.4 8.5 8.2-2.2-1.8-5-2.8-8.4-2.8-3.5 0-6.4 1.1-8.8 3.2Z',
  },
  'human-curly': {
    hair: '#3f2a1d',
    skin: '#f1c6a8',
    shirt: '#a7f3d0',
    mouth: '#9a3412',
    hairPath: 'M14.2 20.5c-.5-5.6 3.8-10.8 9.7-10.8 5.8 0 10 4.7 9.8 10.3-.7-.7-1.5-1.1-2.4-1.2-.5-2-1.8-3.2-3.7-3.4-.7-1.3-1.9-2-3.6-2-1.8 0-3 .7-3.7 2-1.9.2-3.2 1.3-3.8 3.2-.8.2-1.6.8-2.3 1.9Z',
  },
  'human-long': {
    hair: '#111827',
    skin: '#f0c7a6',
    shirt: '#fecdd3',
    mouth: '#9a3412',
    hairPath: 'M14.3 29.9V19.2c0-5.6 4-9.8 9.7-9.8s9.7 4.2 9.7 9.8v10.7c-2.4-.7-4-2.6-4.5-5.8-.8-4.8-2.5-7.3-5.2-7.3-2.8 0-4.5 2.5-5.2 7.3-.5 3.2-2.1 5.1-4.5 5.8Z',
  },
  'human-buzz': {
    hair: '#5b4636',
    skin: '#d5a07d',
    shirt: '#fcd34d',
    mouth: '#7c2d12',
    hairPath: 'M16.1 18.2c1.3-3.9 4.5-6.1 7.9-6.1 3.5 0 6.6 2.1 7.9 5.9-2.5-1.1-5.2-1.6-7.9-1.6-2.7 0-5.4.6-7.9 1.8Z',
  },
  'human-wavy': {
    hair: '#6b3f2a',
    skin: '#f1d0b5',
    shirt: '#c4b5fd',
    mouth: '#9a3412',
    hairPath: 'M13.8 20.2c.5-5.8 4.4-10.1 10.1-10.1 5.7 0 9.6 4.1 10.2 9.8-1.1-.8-2.2-1.3-3.2-1.4-.7-1.8-2.1-3.2-4-3.8-.8.8-1.8 1.2-3 1.2-1.2 0-2.2-.4-3-1.1-1.9.6-3.4 2-4.2 4-.9.2-1.9.7-2.9 1.4Z',
  },
  'human-parted': {
    hair: '#2b2a33',
    skin: '#ebbf9a',
    shirt: '#86efac',
    mouth: '#7c2d12',
    hairPath: 'M15.1 20.4c0-5.4 4.1-9.7 8.9-9.7 4.7 0 8.8 4.1 8.8 9.4-1.8-1.8-3.9-3.1-6.2-3.8l-2.2 2.2-2.1-2.1c-2.7.7-5.1 2-7.2 4Z',
  },
  'human-coily': {
    hair: '#25160f',
    skin: '#9f6f4f',
    shirt: '#f9a8d4',
    mouth: '#7c2d12',
    hairPath: 'M13.8 21c.2-2 1.2-3.3 2.9-3.9.2-2.1 1.5-3.4 3.7-3.8.8-1.6 2-2.4 3.7-2.4 1.8 0 3.1.8 3.8 2.5 2 .4 3.2 1.6 3.6 3.6 1.7.5 2.7 1.7 3 3.8-1.5-.9-3.1-1.5-4.8-1.9-1.8 1.4-3.7 2.1-5.6 2.1-2 0-3.8-.7-5.5-2-1.8.4-3.5 1.1-4.8 2Z',
  },
  'human-bob': {
    hair: '#432818',
    skin: '#f0c9a3',
    shirt: '#7dd3fc',
    mouth: '#9a3412',
    hairPath: 'M14.6 30.4V19.7c0-5.7 4-9.8 9.4-9.8 5.4 0 9.4 4.1 9.4 9.8v10.7c-1.7-.3-3-1.1-3.9-2.5v-7.3c0-2.8-2.2-5.2-5.5-5.2-3.4 0-5.5 2.4-5.5 5.2v7.3c-.9 1.4-2.2 2.2-3.9 2.5Z',
  },
  'human-sweep': {
    hair: '#47311d',
    skin: '#d9a882',
    shirt: '#fdba74',
    mouth: '#7c2d12',
    hairPath: 'M14.2 19.5c1.5-5.4 5.6-8.9 10.2-8.9 4.2 0 7.4 2.1 9.1 6.1-2.4-.3-4.8.1-7.2 1.2-2.3 1.1-4.5 1.6-6.7 1.6-1.7 0-3.5 0-5.4 0Z',
  },
  'human-ponytail': {
    hair: '#2f2219',
    skin: '#f1c9aa',
    shirt: '#f9a8d4',
    mouth: '#9a3412',
    hairPath: 'M14.6 30.7V19.8c0-5.5 4-9.6 9.4-9.6 5.3 0 9.4 4.1 9.4 9.6v10.9c-1.8-.6-3-2-3.7-4.1V19c0-2.2-2.2-3.9-5.1-3.9S19.7 16.8 19.7 19v7.6c-.7 2.1-1.9 3.5-3.7 4.1Z',
  },
  'human-bangs': {
    hair: '#3b2a20',
    skin: '#e4b38a',
    shirt: '#c4b5fd',
    mouth: '#7c2d12',
    hairPath: 'M14 30V19.3c0-5.6 4.1-9.8 9.8-9.8s9.8 4.2 9.8 9.8V30c-1.5-.6-2.8-1.8-3.7-3.5v-6.5c-1.1-1.7-2.5-2.6-4.2-2.6s-3.1.5-4.3 1.4c-1.3-1-2.7-1.5-4.1-1.5-1 0-1.9.2-2.9.6-.2.3-.3.7-.4 1.1Z',
  },
  'human-braids': {
    hair: '#28140d',
    skin: '#b8805f',
    shirt: '#fda4af',
    mouth: '#7c2d12',
    hairPath: 'M15 31.4V19.7c0-5.3 3.9-9.3 9-9.3s9 4 9 9.3v11.7c-1.2-.1-2.1-.7-2.8-1.8l-.7-7.8c-.3-2.7-2.2-4.5-5.5-4.5s-5.2 1.8-5.5 4.5l-.7 7.8c-.7 1.1-1.6 1.7-2.8 1.8Z',
  },
  'human-fade': {
    hair: '#1f2937',
    skin: '#d3a07d',
    shirt: '#93c5fd',
    mouth: '#7c2d12',
    hairPath: 'M15.7 18.8c1.5-4.3 4.8-6.8 8.5-6.8 3.8 0 7.2 2.4 8.5 6.6-2.1-1-4.9-1.5-8.4-1.5-3.4 0-6.3.6-8.6 1.7Z',
  },
  'human-shag': {
    hair: '#4a3426',
    skin: '#f0ceb0',
    shirt: '#86efac',
    mouth: '#9a3412',
    hairPath: 'M13.7 21.1c.4-5.6 4.1-10.2 9.9-10.2 5.8 0 10 4.3 10.3 10-.9-.7-1.8-1.2-2.7-1.5-1-1.7-2.5-3-4.6-3.6-1 .9-2 1.3-3.1 1.3s-2.2-.4-3.3-1.3c-1.9.7-3.4 2.1-4.4 4-.7.1-1.4.6-2.1 1.3Z',
  },
};

const optionIds = new Set(USER_AVATAR_OPTIONS.map((option) => option.id));
const backgroundIds = new Set(USER_AVATAR_BACKGROUNDS.map((background) => background.id));

function clampAvatarBackgroundHue(value) {
  const numeric = Number.parseInt(value, 10);
  if (Number.isNaN(numeric)) {
    return Number.parseInt(DEFAULT_USER_AVATAR_PREF.avatarBackground, 10);
  }
  return Math.min(USER_AVATAR_BACKGROUND_SLIDER_MAX, Math.max(USER_AVATAR_BACKGROUND_SLIDER_MIN, numeric));
}

function normalizeAvatarBackgroundValue(rawAvatarBackground) {
  if (backgroundIds.has(rawAvatarBackground)) {
    const legacyBackground = USER_AVATAR_BACKGROUNDS.find((background) => background.id === rawAvatarBackground);
    return String(legacyBackground?.hue ?? DEFAULT_USER_AVATAR_PREF.avatarBackground);
  }

  return String(clampAvatarBackgroundHue(rawAvatarBackground));
}

export function normalizeUserAvatarPreference(preference = {}) {
  const rawAvatarId = preference.avatarId ?? preference.avatar_id;
  const rawAvatarBackground = preference.avatarBackground ?? preference.avatar_background;

  return {
    avatarId: optionIds.has(rawAvatarId) ? rawAvatarId : DEFAULT_USER_AVATAR_PREF.avatarId,
    avatarBackground: normalizeAvatarBackgroundValue(rawAvatarBackground),
  };
}

export function getUserAvatarBackgroundColor(avatarBackground) {
  const normalized = normalizeUserAvatarPreference({ avatarBackground });
  const hue = clampAvatarBackgroundHue(normalized.avatarBackground);
  return `hsl(${hue} 88% 92%)`;
}

export function UserAvatarIcon({ avatarId, avatarBackground, backgroundColorOverride, className = '' }) {
  const normalized = normalizeUserAvatarPreference({ avatarId, avatarBackground });
  const variant = AVATAR_VARIANTS[normalized.avatarId] ?? AVATAR_VARIANTS[DEFAULT_USER_AVATAR_PREF.avatarId];
  const backgroundColor = backgroundColorOverride ?? getUserAvatarBackgroundColor(normalized.avatarBackground);

  return (
    <svg className={className} viewBox="0 0 48 48" aria-hidden="true" focusable="false">
      <circle cx="24" cy="24" r="22" fill={backgroundColor} />
      <path d="M13 39c1.9-6.5 6.7-9.7 11-9.7S33.1 32.5 35 39" fill={variant.shirt} />
      <circle cx="24" cy="19" r="8.5" fill={variant.skin} />
      <path d={variant.hairPath} fill={variant.hair} />
      <circle cx="21" cy="18.8" r="1" fill="#1f2937" />
      <circle cx="27" cy="18.8" r="1" fill="#1f2937" />
      <path d="M21 22.5c1.1.7 4 .7 6 0" stroke={variant.mouth} strokeWidth="1.4" strokeLinecap="round" />
    </svg>
  );
}

export function HumanAvatarIcon() {
  return <UserAvatarIcon />;
}

export function AimieRobotAvatarIcon() {
  return (
    <svg viewBox="0 0 48 48" aria-hidden="true" focusable="false">
      <circle cx="24" cy="24" r="22" fill="#6f8a90" />
      <path d="M8 14.2 24 8l16 6.2v2.3H8z" fill="#2f2a23" stroke="#2f2a23" strokeLinejoin="round" />
      <path d="M35.7 14.4h2.1v8.2c0 1.1-.9 2-2 2h-.1z" fill="#d5a03d" />
      <circle cx="36.7" cy="14.5" r="1.1" fill="#d5a03d" />
      <rect x="11" y="15" width="26" height="21" rx="4.8" fill="#71878c" stroke="#2f2a23" strokeWidth="1.7" />
      <circle cx="19" cy="24" r="5.3" fill="#f4dfba" stroke="#2f2a23" strokeWidth="1.2" />
      <circle cx="29" cy="24" r="5.3" fill="#f4dfba" stroke="#2f2a23" strokeWidth="1.2" />
      <circle cx="19" cy="24" r="1.8" fill="#2f2a23" />
      <circle cx="29" cy="24" r="1.8" fill="#2f2a23" />
      <rect x="19" y="30" width="10" height="2.8" rx="1.4" fill="#2f2a23" />
      <circle cx="10.5" cy="24.5" r="2.6" fill="#5f757b" stroke="#2f2a23" strokeWidth="1.2" />
      <circle cx="37.5" cy="24.5" r="2.6" fill="#5f757b" stroke="#2f2a23" strokeWidth="1.2" />
    </svg>
  );
}
